import React, { Component } from 'react'
import axios from 'axios'
import Base from './Config'
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import WaveLoading from 'react-loadingg/lib/WaveLoading';
import { TextArea } from 'semantic-ui-react';
import { Modal,ButtonToolbar,Button } from 'react-bootstrap';
import happy from "./assets/img/theme/happy.png"
import sad from "./assets/img/theme/sad.png"
import poor from "./assets/img/theme/poor.png"

import score1 from './assets/img/icons/1.png'
import score2 from './assets/img/icons/2.png'
import score3 from './assets/img/icons/3.png'
import score4 from './assets/img/icons/4.png'
import score5 from './assets/img/icons/5.png'

class MyVerticallyCenteredModal extends React.Component {
    constructor(){
        super()
        this.state = {
        }
    }
    submitForm=()=>{
        this.props.onHide()
    }
    // componentDidMount(){
    //     this.fetchAllData()
    // }
    // fetchAllData=()=>{
    //     axios.get(
    //       Base.url+'Quotation/?id='+this.props.data,
    //       { 
    //           headers: { 
    //               'Authorization': 'Token '+localStorage.getItem('Token'),
    //           } 
    //       }
    //     ).then(response => {
    //         this.setState({
    //             data:response.data.results[0],
    //             loading:false,
    //         })
    //     }).catch(error => {
    //         console.log('Error loading quotation count: ', error);
    //         NotificationManager.error('Error : ', error, 10000);
    //     })
    // }
    render() {
        const data = this.props.data

        var id =""
        var date =  ""
        var orderdate=""
        var username=""
        var mobile =""
        var servicename=""
        var desc=""

        data.map(item=>{
            id = item.id
            date =item.date.toDateString()
            orderdate = item.orderdate.toDateString()
            username = item.username
            mobile = item.mobile
            servicename = item.servicename
            desc = item.desc
        })
        

        return (
            <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Quotation Details : 
                    {id}
        </Modal.Title>
            </Modal.Header>
            <Modal.Body >
                    <table align="center" >
                    <tbody>
                    <tr>
                        <td >
                            Order Date
                        </td>
                        <td>
                        {orderdate}
                        {/* {orderdate.getDate()}/{orderdate.getMonth()}/{orderdate.getFullYear()} */}
                        </td>
                        
                    </tr>
                    <tr>
                        
                        <td>
                        Quotation Date :
                        </td>
                        <td>
                        {date}
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Username
                        </td>
                        <td>
                        {username}
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Mobile
                        </td>
                        <td>
                        {mobile}
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Service Name
                        </td>
                        <td>
                        {servicename}
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Description
                        </td>
                        <td>
                        {desc}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.submitForm}>Submit</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}




class Items extends Component {
    constructor(){
        super()
        this.state={
            QuotationModal:false,

            data:[],
            id:"",
        }
    }
    fetchAllData=()=>{
        this.setState({
            loading:true,
        })
        axios.get(
          Base.url+'Quotation/?id='+this.state.id,
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response => {
            console.log(response.data.results[0])
            this.setState({
                data:[
                    {"id":response.data.results[0].id,
                    "date":new Date(response.data.results[0].date),
                    "orderdate":new Date(response.data.results[0].order.date),
                    "username":response.data.results[0].order.user_det.user.username,
                    "mobile":response.data.results[0].order.user_det.mobile,
                    "servicename":response.data.results[0].order.service.name,
                    "desc":response.data.results[0].description,
                    }
                ],
                loading:false,
                QuotationModal:true,

                
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 10000);
        })
    }

    openModal=(id)=>{
        // this.props.data
        console.log('qid ',id );
        this.setState({
            id:id
        },()=>{
            this.fetchAllData()
        })
        
        
        // this.setState({
        // })
    }
    render() {
        // console.log('props ',this.props.data);
        const data = this.props.data
        return (
        <tr>
        <td scope="col">
            {data.score===1&&<img height={30} src={score5}/>}
            {data.score===2&&<img height={30} src={score4}/>}
            {data.score===3&&<img height={30} src={score3}/>}
            {data.score===4&&<img height={30} src={score2}/>}
            {data.score===5&&<img height={30} src={score1}/>}
            &nbsp;
            {data.username}
            </td>
        <td scope="col"><TextArea name="note" value={data.note}  className="form-control form-control-lg" disabled></TextArea></td>
        <td scope="col">

            <MyVerticallyCenteredModal
                show={this.state.QuotationModal}
                onHide={() => this.setState({ QuotationModal: false })}
                data={this.state.data}
            />

            {this.state.loading?<WaveLoading color={"grey"}/>
            :
            <button
             onClick={()=>this.openModal(data.quotation)}
             className="btn btn-sm btn-primary" >
            View Quotation
            </button>
            }
            </td>
        </tr>
        );
    }
}


export default class Feedback extends React.Component {
    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,
            loading:false,

            // QuotationModal:false,
        }
    }

    loading=(args)=>{
        this.setState({
            loading:args
        })
    }

    componentDidMount(){
        this.fetchAllData()
    }

    next=()=>{
        this.loading(true)
        axios.get(
          this.state.next,
          { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false, 

          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    prev=()=>{
        this.loading(true)
        axios.get(
          this.state.prev,
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchAllData(){
        this.loading(true)
        axios.get(
            Base.url + 'Feedback/',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading:false,
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    render() {
        return (
            <div>
      {/* <NotificationContainer/> */}

        <NavigationItems/>
        <div  className="main-content">
          <PageHeader pageName={'Feedback'}/>

          <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
            <div className="container-fluid">
              <div className="header-body">
                {/* Card stats */}
                {/* <div className="row">
                
                  <QuotationComponent filterQuotation={()=>this.filterQuotation('onquotation')} heading={'On quotation'} style={'fa fa-fw fa-circle text-blue'} count={this.state.countQuotaion} subHeading={'Quotation'}/>
                  <QuotationComponent filterQuotation={()=>this.filterQuotation('pending')} heading={'Pending'} style={'fa fa-fw fa-circle text-red'} count={this.state.countPending} subHeading={'Quotation'}/>
                  <QuotationComponent filterQuotation={()=>this.filterQuotation('scheduled')} heading={'Scheduled'} style={'fa fa-fw fa-circle text-yellow'} count={this.state.countScheduled} subHeading={'Quotation'}/>
                  <QuotationComponent filterQuotation={()=>this.filterQuotation('compconsted')} heading={'Compconsted'} style={'fa fa-fw fa-circle text-green'} count={this.state.countCompconsted} subHeading={'Quotation'}/>
                  <QuotationComponent filterQuotation={()=>this.filterQuotation('cancelled')} heading={'Cancelled'} style={'fa fa-fw fa-circle text-black'} count={this.state.countCancelled} subHeading={'Quotation'}/>

                </div> */}
              </div>
            </div>
          </div>
          
          {/* Page content */}
          <div className="container-fluid mt--7">
            <div className="row">

              {/* left main items */}
              <div className="col-xl-12 mb-5 mb-xl-0">
                <div className="card shadow">
                  <div className="card-header border-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="mb-0">{this.state.filter&&<button className="btn btn-sm bg-translucent-secondary" onClick={this.clearFilter}>clear filter</button>} Feedback 
                        {this.state.filter&&<span className="text-muted text-sm">{' / '+this.state.filter}</span>} 
                        </h3>
                        

                      </div>
                      <div className="col text-right">
                        {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                        {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                      </div>
                    </div>
                  </div>

                 
                  <div className="table-responsive">
                  {this.state.loading?<WaveLoading/>:
                      <table className="table align-items-center table-flush">
                          <thead className="thead-light">
                              <tr>
                                  <th scope="col">Username</th>
                                  <th scope="col">Feedback</th>
                                  <th scope="col">Quotation</th>
                              </tr>
                          </thead>
                          <tbody>
                               

                          {
                            this.state.data.map((item,index) => {
                              return <Items 
                              key={index} 
                              data={item} 
                              />
                            })
                            
                          }
                          </tbody>
                      </table>
                  }
                  </div>
                </div>
              </div>
            </div>
            {/* <Footer/> */}
          </div>
        </div>
      </div>
        );
    }
}



